
document.addEventListener("DOMContentLoaded", function() {
  // ========== ELEMENT SELECTORS ==========
  const hiddenPlanInput = document.querySelector(".hidden-selling-plan");
  const hiddenVariantInput = document.querySelector(".cs-product-variant");
  const bundleRadios = document.querySelectorAll("input[name='bundle_option']");
  const bundleCards = document.querySelectorAll(".bundle-card");
  const frequencyInputs = document.querySelectorAll("input[name='frequency_option']");
  const sellingPlanSelects = document.querySelectorAll("select[name='selling_plan']");
  
  let currentFrequency = "subscription"; // default

  // ========== UTILITY FUNCTIONS ==========
  
  function getActiveSubscriptionDropdown() {
    // Find all selling plan dropdowns
    const allDropdowns = document.querySelectorAll("select[name='selling_plan']");
    
    // Find the visible one (not display:none and not in a hidden parent)
    for (let dropdown of allDropdowns) {
      const isHidden = dropdown.style.display === 'none' || 
                       dropdown.closest('[style*="display: none"]') ||
                       dropdown.closest('[style*="display:none"]') ||
                       dropdown.offsetParent === null; // checks if element or parent is hidden
      
      if (!isHidden) {
        return dropdown;
      }
    }
    
    return null;
  }

  function identifyFrequencyCards() {
    const allFrequencyCards = document.querySelectorAll(".frequency-card");

    allFrequencyCards.forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      if (!input) return;

      const hasSellingPlan = card.querySelector("select[name='selling_plan']");
      const isSubscription = hasSellingPlan || input.hasAttribute("data-subscription-serving-");

      if (isSubscription) {
        card.classList.add("subscription");
      } else {
        if (!card.classList.contains("one-time")) {
          card.classList.add("one-time");
        }
      }
    });
  }

  function detectCurrentFrequency() {
    const checkedInput = document.querySelector("input[name='frequency_option']:checked");
    if (checkedInput) {
      const card = checkedInput.closest(".frequency-card");
      currentFrequency = card && card.classList.contains("subscription") ? "subscription" : "onetime";
    }
  }

  // ========== PRICE UPDATE FUNCTIONS ==========

  function updateAllBundleCardPrices() {
    bundleCards.forEach(card => {
      const priceEl = card.querySelector(".price");
      const comparePriceEl = card.querySelector(".cs_compare");

      if (!priceEl) return;

      const oneTimePrice = priceEl.getAttribute("data-price-onetime");
      const discountedPrice = priceEl.getAttribute("data-discounted-price");
      const comparePrice = priceEl.getAttribute("data-compare-price");

      // Update price based on frequency
      if (currentFrequency === "subscription") {
        priceEl.textContent = discountedPrice || oneTimePrice;

        // Show compare price for subscription
        if (comparePriceEl && comparePrice) {
          comparePriceEl.style.display = "none";
          comparePriceEl.textContent = comparePrice;
        }

      } else {
        // One-time purchase
        priceEl.textContent = oneTimePrice;

        // Hide compare price for one-time
        if (comparePriceEl) {
          comparePriceEl.style.display = "none";
        }
      }
    });
  }

  function updateFrequencySectionPrices() {
    const activeBundle = document.querySelector("input[name='bundle_option']:checked");
    if (!activeBundle) return;

    const activeBundleCard = activeBundle.closest(".bundle-card");
    const priceEl = activeBundleCard.querySelector(".price");
    if (!priceEl) return;

    const oneTimePrice = priceEl.getAttribute("data-price-onetime");
    const discountedPrice = priceEl.getAttribute("data-discounted-price");
    const comparePrice = priceEl.getAttribute("data-compare-price");

    const allFrequencyCards = document.querySelectorAll(".frequency-card");
    allFrequencyCards.forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      const currentPriceEl = card.querySelector(".current-price");
      const comparePriceEl = card.querySelector(".cs_compare, .cs_compare1, .compare-price");
      if (!input) return;

      const isSubscription = card.classList.contains("subscription");

      // Update price
      if (currentPriceEl) {
        currentPriceEl.textContent = isSubscription ? discountedPrice : oneTimePrice;
      }

      // Show/hide compare price
      if (comparePriceEl) {
        if (isSubscription && comparePrice) {
          comparePriceEl.style.display = "inline-block";
          comparePriceEl.textContent = comparePrice;
        } else {
          comparePriceEl.style.display = "none";
        }
      }
    });
  }

  function updateActiveFrequencyCard() {
    document.querySelectorAll(".frequency-card").forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      card.classList.toggle("active", input && input.checked);
    });
  }

  // ========== UPDATE BUNDLE CARD ELEMENTS ==========
  function updateBundleCardElements() {
    bundleCards.forEach(card => {
      const radio = card.querySelector("input[name='bundle_option']");
      if (!radio) return;

      const isChecked = radio.checked;
      const saveBadge = card.querySelector(".save-badge");
      const serAll = card.querySelector(".ser-all");

      // Get attributes
      const onetimeSave = radio.getAttribute("onetime-save");
      const subSave = radio.getAttribute("sub-save");
      const perSerOne = radio.getAttribute("per-ser-one");
      const perSerSub = radio.getAttribute("per-ser-sub");

      // Update elements based on frequency for ALL cards
      if (currentFrequency === "onetime") {
        if (saveBadge && onetimeSave) saveBadge.textContent = onetimeSave;
        if (serAll && perSerOne) serAll.textContent = perSerOne;
      } else {
        if (saveBadge && subSave) saveBadge.textContent = subSave;
        if (serAll && perSerSub) serAll.textContent = perSerSub;
      }
    });
  }

  // ========== UPDATE EXTERNAL ELEMENTS ==========
  function updateExternalElements() {
    const checkedRadio = document.querySelector("input[name='bundle_option']:checked");
    if (!checkedRadio) return;

    const checkedCard = checkedRadio.closest(".bundle-card");
    const priceEl = checkedCard.querySelector(".price");

    // Get attributes from checked radio
    const perSerOne = checkedRadio.getAttribute("per-ser-one");
    const perSerSub = checkedRadio.getAttribute("per-ser-sub");
    const serNo = checkedRadio.getAttribute("ser-no");
    const onetimeSave = checkedRadio.getAttribute("onetime-save");
    const subSave = checkedRadio.getAttribute("sub-save");

    // Update .ser-onetime and .ser-sub
    const serOnetimeEl = document.querySelector(".ser-onetime");
    const serSubEl = document.querySelector(".ser-sub");
    if (serOnetimeEl && perSerOne) serOnetimeEl.textContent = perSerOne;
    if (serSubEl && perSerSub) serSubEl.textContent = perSerSub;

    // Update .subtitle-subscription
    const subtitleSubEl = document.querySelector(".subtitle-subscription");
    if (subtitleSubEl && serNo) subtitleSubEl.textContent = serNo;

    // Update .bundle-sub-dis based on frequency
    const bundleSubDisEl = document.querySelector(".bundle-sub-dis");
    if (bundleSubDisEl) {
      if (currentFrequency === "onetime" && onetimeSave) {
        bundleSubDisEl.textContent = onetimeSave;
      } else if (currentFrequency === "subscription" && subSave) {
        bundleSubDisEl.textContent = subSave;
      }
    }

    // Update .new-sub-total based on frequency
    if (priceEl) {
      const onetimePrice = priceEl.getAttribute("data-price-onetime");
      const discountedPrice = priceEl.getAttribute("data-discounted-price");
      const newSubTotalEl = document.querySelector(".new-sub-total");
      
      if (newSubTotalEl) {
        if (currentFrequency === "onetime" && onetimePrice) {
          newSubTotalEl.textContent = onetimePrice;
        } else if (currentFrequency === "subscription" && discountedPrice) {
          newSubTotalEl.textContent = discountedPrice;
        }
      }
    }
  }

  // ========== HIDE COMPARE PRICE IF EQUAL ==========
  function handleComparePriceVisibility() {
    bundleCards.forEach(card => {
      const priceEl = card.querySelector(".price");
      const comparePriceEl = card.querySelector(".cs_compare-price");
      
      if (priceEl && comparePriceEl) {
        const priceText = priceEl.textContent.trim();
        const compareText = comparePriceEl.textContent.trim();
        
        if (priceText === compareText) {
          comparePriceEl.style.display = "none";
        } else {
          comparePriceEl.style.display = "";
        }
      }
    });
  }

  // ========== HIDDEN INPUT UPDATE FUNCTION ==========
  
  function updateHiddenInputs(trigger = "auto") {
    const activeBundle = document.querySelector("input[name='bundle_option']:checked");
    const activeFrequency = document.querySelector("input[name='frequency_option']:checked");

    // Update variant ID
    if (hiddenVariantInput) {
      hiddenVariantInput.value = activeBundle ? activeBundle.value || "" : "";
    }

    // Update selling plan
    if (!hiddenPlanInput) return;

    if (!activeBundle || !activeFrequency) {
      // Don't clear - keep existing value if no selection
      return;
    }

    const isSubscription = activeFrequency.closest(".frequency-card")?.classList.contains("subscription");

    if (isSubscription) {
      // For subscription, IMMEDIATELY get the value from the active dropdown
      const dropdown = getActiveSubscriptionDropdown();
      if (dropdown && dropdown.value) {
        hiddenPlanInput.value = dropdown.value;
        console.log("💡 Setting selling plan from active dropdown →", dropdown.value);
      } else if (trigger !== "plan select") {
        // If no dropdown found and not triggered by dropdown, check all dropdowns
        const anyDropdown = document.querySelector("select[name='selling_plan']");
        if (anyDropdown && anyDropdown.value) {
          hiddenPlanInput.value = anyDropdown.value;
          console.log("💡 Setting selling plan from any dropdown →", anyDropdown.value);
        }
      }
      // Don't clear if no dropdown found - keep existing value
    } else {
      // Only clear for one-time purchase
      hiddenPlanInput.value = "";
    }

    console.log(
      `💡 [${trigger}] Variant: ${hiddenVariantInput?.value || "(empty)"} | Selling Plan: ${hiddenPlanInput?.value || "(empty)"}`
    );
  }

  // ========== INITIALIZATION ==========

  // Identify frequency cards
  identifyFrequencyCards();
  detectCurrentFrequency();

  // ========== EVENT LISTENERS ==========

  // Frequency input change
  frequencyInputs.forEach(input => {
    input.addEventListener("change", function() {
      currentFrequency = this.closest(".frequency-card").classList.contains("subscription")
        ? "subscription"
        : "onetime";

      updateAllBundleCardPrices();
      updateFrequencySectionPrices();
      updateActiveFrequencyCard();
      updateBundleCardElements();
      updateExternalElements();
      handleComparePriceVisibility();
      updateHiddenInputs("frequency change");
    });
  });

  // Bundle radio change
  bundleRadios.forEach((radio) => {
    radio.addEventListener("change", function() {
      updateAllBundleCardPrices();
      updateFrequencySectionPrices();
      updateActiveFrequencyCard();
      updateBundleCardElements();
      updateExternalElements();
      handleComparePriceVisibility();
      updateHiddenInputs("bundle change");
      
      // Recheck after delay in case subscription dropdown toggles
      setTimeout(() => updateHiddenInputs("bundle delayed recheck"), 200);
    });
  });

  // Selling plan dropdown change
  sellingPlanSelects.forEach(select => {
    select.addEventListener("change", function() {
      // Immediately update the hidden input with the selected value
      if (hiddenPlanInput) {
        hiddenPlanInput.value = this.value;
        console.log("💡 [dropdown change] Selling plan updated →", this.value);
      }
      updateHiddenInputs("plan select");
    });
  });

  // ========== INITIAL LOAD ==========
  
  updateAllBundleCardPrices();
  updateFrequencySectionPrices();
  updateActiveFrequencyCard();
  updateBundleCardElements();
  updateExternalElements();
  handleComparePriceVisibility();
  
  // Initialize hidden inputs with delay to ensure DOM is ready
  setTimeout(() => updateHiddenInputs("initial load"), 200);
});
